import api from '../../plugins/api';

// ÐÐ¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÐµÑ SMS-ÐºÐ¾Ð´ Ð¸ Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°ÐµÑ Ñ backend Doscar Ð´Ð°Ð½Ð½ÑÐµ ÑÐ¸ÑÑÐ¾Ð²Ð¾Ð³Ð¾
// ÑÐ´Ð¾ÑÑÐ¾Ð²ÐµÑÐµÐ½Ð¸Ñ Ð»Ð¸ÑÐ½Ð¾ÑÑÐ¸ (ÐÐÐ FCB ID OTP). requestId Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð±ÑÑÑ ÑÐµÐ¼ Ð¶Ðµ,
// ÑÑÐ¾ Ð²ÐµÑÐ½ÑÐ» pkbFcbSendCode.
const pkbFcbGetDocument = (id, { requestId, code }) => {
  return api.post(`/api/crm/clients/${id}/fcbid/document`, { requestId, code });
};

export default pkbFcbGetDocument;